import { render, staticRenderFns } from "./AmazeNotifications.vue?vue&type=template&id=052d864e&scoped=true"
import script from "./AmazeNotifications.vue?vue&type=script&lang=js"
export * from "./AmazeNotifications.vue?vue&type=script&lang=js"
import style0 from "./AmazeNotifications.vue?vue&type=style&index=0&id=052d864e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052d864e",
  null
  
)

export default component.exports